<template>
  <Toast/>
  <div class="row">
    <div class="col-12">
      <h2 class="titre">
        Copier les rôles d'un groupe de sécurité source à un groupe de sécurité destination
      </h2>
    </div>
  </div>
  <CriteresRechercheRolesGroupe ref="criteresRechercheRolesGroupe" @fermer="fermer"/>
  <InformationJustification ref="informationJustification"/>
  <div class="row"/>
  <div class="row">
    <div class="col">
      <Button label="Sauvegarder" v-on:click="sauvegarder"/>
    </div>
    <div class="col">
      <Button label="Audit" v-on:click="audit"/>
    </div>
    <div class="col">
      <Button label="Fermer" v-on:click="fermer"/>
    </div>
  </div>
</template>

<script>
import CriteresRechercheRolesGroupe
  from "@/components/pilotage/CopieRolesGroupeSecurite/CriteresRechercheRolesGroupe.vue";
import InformationJustification from "@/components/pilotage/CopieRolesGroupeSecurite/InformationJustification.vue";
import {mapGetters} from "vuex";
import axios from "axios";

export default {
  name: "CopieRolesGroupe",
  components: {
    CriteresRechercheRolesGroupe,
    InformationJustification
  },
  computed: {
    ...mapGetters({
      jeton: 'cardex/jeton',
      profil: 'cardex/profil',
    })
  },
  mounted() {
    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$root.$refs.breadcrumbComp.ajout("Copie de rôles");
  },
  methods: {
    sauvegarder(){
      this.$root.$refs.breadcrumbComp.activeBallBeat = true;
      let groupesSecuriteVO={};
      groupesSecuriteVO.cle = this.$refs.criteresRechercheRolesGroupe.getGroupe();
      groupesSecuriteVO.groupeRolesVO = this.$refs.criteresRechercheRolesGroupe.getRolesAttribues();
      groupesSecuriteVO.justificationVO = this.$refs.informationJustification.getJustification();
      this.$store.dispatch("pilotage/sauvegarderGroupeRoleAction", groupesSecuriteVO)
          .then(() => {
            this.$toast.add({
              severity: 'success',
              summary: 'Modification RolesAttribues',
              detail: 'Les rôles ont été mis à jour.',
              life: 6000
            });
            groupesSecuriteVO.justification = this.$refs.informationJustification.clearJustification();
          });
      this.$root.$refs.breadcrumbComp.activeBallBeat = false;
    },
    audit() {
      this.$router.push({
        name: 'rolesGroupeAuditModifications',
        params: {cle: this.$refs.criteresRechercheRolesGroupe.getGroupe()}
      });
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
  }
}
</script>
